import { ActionIcon, CopyButton as MantineCopyButton, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";

/** Small inline "copy to clipboard" affordance for ids / addresses / hashes. */
export function CopyButton({ value }: { value: string }) {
  return (
    <MantineCopyButton value={value} timeout={1500}>
      {({ copied, copy }) => (
        <Tooltip label={copied ? "Copied" : "Copy"} withArrow>
          <ActionIcon
            color={copied ? "teal" : "gray"}
            variant="subtle"
            size="sm"
            onClick={copy}
            aria-label="Copy"
          >
            {copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
          </ActionIcon>
        </Tooltip>
      )}
    </MantineCopyButton>
  );
}
